import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));
export const Dashboard = Loadable(lazy(() => import('../pages/dashboard/Dashboard')));
export const VendorsList = Loadable(lazy(() => import('../pages/vendors/VendorsList')));
export const CreateEditVendor = Loadable(lazy(() => import('../pages/vendors/CreateEditVendor')));
export const Platformhistroy = Loadable(lazy(() => import('../pages/vendors/Platformhistroy')))

export const UpdateVendor = Loadable(lazy(() => import('../pages/vendors/UpdateVendor')));
export const BusinessTagsList = Loadable(
  lazy(() => import('../pages/business-tags/BusinessTagsList'))
);
export const CreateEditBusinessTags = Loadable(
  lazy(() => import('../pages/business-tags/CreateEditBusinessTags'))
);
export const PackagesList = Loadable(lazy(() => import('../pages/packages/PackagesList')));
export const CreateEditpackages = Loadable(
  lazy(() => import('../pages/packages/CreateEditPackages'))
);
export const EventTagsList = Loadable(lazy(() => import('../pages/events-tags/EventTagsList')));
export const CreateEditEventTags = Loadable(
  lazy(() => import('../pages/events-tags/CreateEditEventTags'))
);
export const CancelTickets = Loadable(lazy(() => import('../pages/cancel-tickets/CancelTickets')));
export const AddCancelTickets = Loadable(
  lazy(() => import('../pages/cancel-tickets/AddCancelTicket'))
);
export const TicketOrders = Loadable(lazy(() => import('../pages/ticket-orders/index')));
export const SponsoredEvents = Loadable(
  lazy(() => import('../pages/sponsored-events/SponsoredEventsList'))
);
export const SponsoredEventsCreate = Loadable(
  lazy(() => import('../pages/sponsored-events/CreateUpdateEvents'))
);

export const GroupEvents = Loadable(lazy(() => import('../pages/events-group/GroupList')));
export const CreateGroupEvents = Loadable(lazy(() => import('../pages/events-group/CreateGroup')));
export const Customer = Loadable(lazy(() => import('../pages/customer/Customer')));
export const Events = Loadable(lazy(() => import('../pages/events/Dashboard')));
export const Platform = Loadable(lazy(() => import('../pages/platform/Platform')))
export const SetPlatformfee = Loadable(lazy(() => import('../pages/platform/SetPlatformfee')));
export const UpdatePlatformfee =Loadable(lazy(() => import('../pages/platform/UpdatePlatformfee')))
export const Invoices = Loadable(lazy(() => import('../pages/invoices/Invoices')));
export const CreateInvoice = Loadable(lazy(() => import('../pages/invoices/CreateInvoice')));
export const CustomerInvoice = Loadable(lazy(() => import('../pages/invoices/CustomerInvoice')));

export const CreditsPackageList = Loadable(
  lazy(() => import('../pages/campaign/credits-package/CreditsPackageList'))
);
export const CreateEditCreditPackage = Loadable(
  lazy(() => import('../pages/campaign/credits-package/CreateEditCreditPackage'))
);
export const AddCreditsList = Loadable(
  lazy(() => import('../pages/campaign/add-credits/AddCreditsList'))
);
export const AddCampaignCredits = Loadable(
  lazy(() => import('../pages/campaign/add-credits/AddCampaignCredits'))
);
export const AddTemplateList = Loadable(
  lazy(() => import('../pages/campaign/add-template/AddTemplateList'))
);
export const AddCampaignTemplate = Loadable(
  lazy(() => import('../pages/campaign/add-template/AddCampaignTemplate'))
);
export const Maintenance = Loadable(lazy(() => import('../pages/maintenance')));
export const TableManagement =Loadable(lazy(()=>import('../pages/TableManagement/TableManagement')))

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));

export const EventRecords = Loadable(lazy(()=> import("../pages/events/event-records")));
export const DiscountDashboard = Loadable(lazy(()=>import("../pages/discount/DiscountDashboard")))
export const CreateDiscount =Loadable(lazy(()=>import("../pages/discount/create-discount")))
export const DiscountDetails =Loadable(lazy(()=>import("../pages/discount/discountDetails")));
export const UpdateDiscount =Loadable(lazy(()=>import("../pages/discount/updateDiscount")));
export const VenuesDashboard =Loadable(lazy(()=>import("../pages/venues/VenuesDashboard")))
 
export const VenuePerDetails =Loadable(lazy(()=>import("../pages/venues/venueDetails")))
export const  UpdateVenue =Loadable(lazy(()=>import("../pages/venues/updateVenue")))
export const ArtistDashboard=Loadable(lazy(()=>import("../pages/artist/ArtistDashboard")));
export const ArtistDetails=Loadable(lazy(()=>import('../pages/artist/ArtistDetails')))
export const  EventSlotPage =Loadable(lazy(()=>import("../pages/event-slot/page")))
export const  CreateEventSlotPage =Loadable(lazy(()=>import("../pages/event-slot/SlotCreate")))
export const  EventLabelDashboard =Loadable(lazy(()=>import("../pages/event-label/eventLabelDashboard")))
export const  CreateEventLabel =Loadable(lazy(()=>import("../pages/event-label/create_eventlabel")))
export const  EventCreateStrikeOutPrice =Loadable(lazy(()=>import("../pages/event-strike_out_price/event_create_StrikeOutPrice")))
export const  UpdateEventLabel =Loadable(lazy(()=>import("../pages/event-label/update_eventLabel")))
export const  EventStrikeDashboard =Loadable(lazy(()=>import("../pages/event-strike_out_price/eventStrikeDashboard")))
export const  EventUpdateStrikeOutPrice =Loadable(lazy(()=>import("../pages/event-strike_out_price/updateStrikeEvent")))
export const CreateEvents=Loadable(lazy(()=>import('../pages/events/create_event')))
export const BlogsDashBoard = Loadable(lazy(() => import('../pages/blogs/blogs_dashboard')))
export const CreateBlog = Loadable(lazy(() => import('../pages/blogs/CreateBlog')))
export const BlogPrev = Loadable(lazy(() => import('../pages/blogs/blogPrev')))
export const VenueCategoryDashboard= Loadable(lazy(() => import('../pages/venues/venueCategoryDashboard')))
export const StaffPage= Loadable(lazy(() => import( "../pages/staff/staffPage")))
export const  UpdateStaff= Loadable(lazy(() => import( "../pages/staff/updateStaff")))
export const  BookingSettings= Loadable(lazy(() => import( "../sections/dashboard/tablemanagement/bookingSettings")))
export const  SlotManagementPage= Loadable(lazy(() => import( "../sections/dashboard/tablemanagement/slotManagement/slotmanagmentpage")))

export const  ReOrder= Loadable(lazy(() => import( "../sections/dashboard/tablemanagement/slotManagement/reOrder")))
export const  AddSlotsPage= Loadable(lazy(() => import( "../sections/dashboard/tablemanagement/slotManagement/add-slots-page")))
export const FloorPlan= Loadable(lazy(() => import( "../sections/dashboard/tablemanagement/FloorPlan")))
export const ConfigurationDashboard= Loadable(lazy(() => import( "../pages/configuration/configuation-dashboard")))
export const SettleMentDashboard= Loadable(lazy(() => import( "../pages/settlement/settlement-dashboard")))
export const SettleAmountPage= Loadable(lazy(() => import( "../pages/settlement/settlement-amount-page")))
export const CategoryMappingDashboard= Loadable(lazy(() => import( "../pages/category-mapping/category-mapping-dashboard")))
export const AddCategoryMapping= Loadable(lazy(() => import( "../pages/category-mapping/addcategory-maping")))
export const QRBandDashboard = Loadable(lazy(() => import("../pages/qrband/qrband_dashboard")))
export const QRBandCreate = Loadable(lazy(() => import("../pages/qrband/qrband_create")))











